//客户信息列表

<template>
  <div class="threeLevelMain">
    <!-- <div class="totalAmount">
        <div>
          <p>总金额：<span>{{zje == ''? 0 : zje}}.00</span></p>
          <p>总数量：<span>{{zsl}}</span></p>
        </div>
      </div> -->
    <!-- 头部查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row" v-show="!isFoldQuery">
        <div class="scan_box">
          <span class="sp_scan">公司名称：</span>
          <!-- <el-select v-model="getTabData.corporate_name" placeholder="全部" size="mini">
                    <el-option
                    v-for="item in cnOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select> -->
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.corporate_name"
            placeholder="全部"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">品牌名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.brand_name"
            placeholder="请输入品牌"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">合作性质：</span>
          <el-select
            v-model="getTabData.properties"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            @change="searchBtn"
            clearable
          >
            <el-option
              v-for="item in khlxOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">运营分部：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.group"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operationDepartmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">店长：</span>
          <!-- <el-input class="ip_scan" v-model="getTabData.assign_id" placeholder="请输入店长姓名" size="mini" style="width:200px;"></el-input> -->
          <el-select
            v-model="getTabData.assign_id"
            clearable
            placeholder="全部"
            size="mini"
            @change="searchBtn"
            class="ip_uniform_style"
            filterable
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">组长：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.assign_name_leader"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            filterable
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">销售：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.sale_id"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            filterable
          >
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box" v-if="jurisdiction">
          <span class="sp_scan">销售主管：</span>
          <el-select
            clearable
            @change="salesChange"
            v-model="supervisorId"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="张正松" value="3"></el-option>
            <el-option label="金扬" value="32"></el-option>
            <el-option label="张雯洁" value="5"></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">类目：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.category"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan" style="line-height: 1">实际服务金额：</span>
          <div class="cooperation_amount" style="margin-right: 10px">
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_state"
              placeholder=""
              size="mini"
              style="width: 110px"
            ></el-input>
            <span style="margin: 0 10px">~</span>
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_end"
              placeholder=""
              size="mini"
              style="width: 110px"
            ></el-input>
          </div>
        </div>
        <div class="scan_box">
          <span class="sp_scan">是否分期：</span>
          <el-select
            v-model="getTabData.payment_method"
            clearable
            @change="searchBtn"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">incall：</span>
          <el-select
            v-model="getTabData.incall"
            clearable
            @change="searchBtn"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">主要产品：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.main_products"
            size="mini"
          ></el-input>
        </div>
        <div class="block scan_box">
          <span class="sp_scan">签订时间：</span>
          <el-date-picker
            v-model="valueDate"
            class="date_range"
            :editable="false"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="valueDateChange('contact')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="block scan_box">
          <span class="sp_scan">到期时间：</span>
          <el-date-picker
            v-model="dqsjDate"
            class="date_range"
            :editable="false"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="dueTimeChange('due')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan">到期天数：</span>
          <el-select
            v-model="getTabData.order"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="剩余天数由多到少" value="1"></el-option>
            <el-option label="剩余天数由少到多" value="2"></el-option>
          </el-select>
        </div>
        <!-- 购买人员用于查看所有客户信息（只读） -->
        <div class="scan_box" v-if="userId == '173'">
          <span class="sp_scan">查看状态：</span>
          <el-select
            v-model="getTabData.is_Purchase"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="默认" value=""></el-option>
            <el-option label="所有客户信息（只读）" value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn_area_out" v-show="!isFoldQuery">
        <!-- <el-button 
            size="mini" 
            @click="searchBtn">查询</el-button> -->

        <el-button
          size="mini"
          @click="resetSearch"
          type="primary"
          icon="el-icon-refresh"
          >重置筛选</el-button
        >

        <el-button
          size="mini"
          @click="exportClick"
          v-if="jurisdiction"
          icon="el-icon-download"
          >导出数据</el-button
        >
      </div>
      <!-- 指派客户放入表格内部  2020_10_15 -->
      <!-- <div class="activeBtn">
              <el-button 
                type="primary" 
                size="small" 
                @click="assignVisible = true"
                v-if="jurisdiction">指派客户</el-button>
          </div> -->
      <!-- 折叠区域 -->
      <div class="fold_btn">
        <!-- 展开 -->
        <div
          class="f_open_area little_hands"
          @click="isFoldQuery = !isFoldQuery"
          v-show="!isFoldQuery"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            class="btn_icon_s"
          ></el-button>
          <p class="fold_content">收起</p>
        </div>
        <!-- 折叠 -->
        <div class="f_fold_area" v-show="isFoldQuery">
          <h3>筛选区域</h3>
          <div
            class="f_f_content little_hands"
            @click="isFoldQuery = !isFoldQuery"
          >
            <p class="fold_content">展开</p>
            <el-button
              type="text"
              icon="el-icon-arrow-down"
              class="btn_icon_s"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="account-view">
      <div class="ac-result">
        <span class="label">总金额：</span>
        <!-- <countTo class="cn_num" :startVal='0' :endVal='zje || 0' :duration='2000'></countTo> -->
        <span class="cn_num">{{ zje || 0 }}</span>
      </div>
      <div class="ac-result">
        <span class="label">总数量：</span>
        <!-- <countTo class="cn_num" :startVal='0' :endVal='zsl || 0' :duration='1000'></countTo> -->
        <span class="cn_num">{{ zsl || 0 }}</span>
      </div>
    </div>

    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
      :recalculateTag="isFoldQuery"
    >
      <el-table-column slot="id" width="75" align="center" label="客户编号">
        <template slot-scope="scope">
          <div>{{ scope.row.customer_id }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="corporate_name"
        align="center"
        width="120"
        label="公司名称"
      >
        <template slot-scope="scope">
          <span
            class="pointer fontColor_theme"
            @click="handleDetail(scope.row)"
            >{{ scope.row.corporate_name }}</span
          >
        </template>
      </el-table-column>

      <!-- 品牌名称 -->
      <el-table-column
        slot="brand_name"
        width="120"
        align="center"
        label="品牌名称"
      >
        <template slot-scope="scope">
          <span
            class="pointer fontColor_theme"
            @click="handleDetail(scope.row)"
            >{{ scope.row.brand_name }}</span
          >
        </template>
      </el-table-column>

      <!-- 签订时间 -->
      <el-table-column
        slot="cooperation_time"
        width="100"
        align="center"
        label="签订时间"
        sortable
        prop="cooperation_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 到期时间 -->
      <el-table-column
        slot="due_time"
        width="100"
        align="center"
        label="到期时间"
        sortable
        prop="due_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.due_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 合同金额 -->
      <el-table-column
        slot="contract_amount"
        width="100"
        align="center"
        label="合同金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.contract_amount }}</div>
        </template>
      </el-table-column>

      <!-- 实际服务金额 -->
      <el-table-column
        slot="cooperation_amount"
        width="100"
        align="center"
        label="实际服务金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_amount }}</div>
        </template>
      </el-table-column>

      <!-- 品牌类型 -->
      <el-table-column
        slot="category"
        width="100"
        align="center"
        label="品牌类型"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.category }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="payment_method"
        width="80"
        align="center"
        label="是否分期"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.payment_method == '1'" class="fontColor_success">
            否
          </div>
          <div v-else class="fontColor_theme">分期</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="properties"
        width="80"
        align="center"
        label="合作性质"
      >
        <template slot-scope="scope">
          <div class="fontColor_theme">
            {{
              scope.row.properties == 1
                ? "新签"
                : scope.row.properties == 2
                ? "续签"
                : scope.row.properties == 3
                ? "新签新增"
                : "续签新增"
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 最近沟通时间 -->
      <el-table-column
        slot="touch_time"
        width="180"
        align="center"
        label="最近沟通时间"
        sortable
        prop="touch_time"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.touch_time == "" ? "未沟通" : scope.row.touch_time }}
          </div>
        </template>
      </el-table-column>

      <!-- 波罗蜜 -->
      <el-table-column
        slot="boluomi"
        width="100"
        align="center"
        label="波罗蜜"
        v-if="jurisdiction"
      >
        <template slot-scope="scope">
          {{ scope.row.boluomi }}
          <!-- {{scope.row.boluomiVisible}} -->
          <el-popover
            placement="top"
            width="300"
            :ref="`re-popover-${scope.$index}`"
            trigger="click"
          >
            <div>
              <el-input
                style="margin-bottom: 10px"
                v-model="scope.row.boluomi"
                type="textarea"
                :rows="5"
                @input="
                  remarkEditConfirm(scope.row, scope.$index, scope._self),
                    scope._self.$refs[`re-popover-${scope.$index}`]
                "
                placeholder="请输入内容"
              ></el-input>
            </div>
            <!-- <div style="text-align: right; margin: 0">
              <el-button
                type="primary"
                size="mini"
                @click="
                  remarkEditConfirm(scope.row, scope.$index, scope._self),
                    scope._self.$refs[`re-popover-${scope.$index}`]
                "
                >确定</el-button
              >
            </div> -->
            <i class="el-icon-edit" slot="reference"></i>
          </el-popover>
        </template>
      </el-table-column>

      <!-- 购买备用金 -->
      <el-table-column
        slot="imprest"
        width="100"
        align="center"
        label="购买备用金"
      >
        <template slot-scope="scope">
          {{ scope.row.imprest }}
          <el-popover
            placement="top-start"
            width="200"
            :ref="`re-popover-${scope.$index}`"
            trigger="click"
            @show="reviseParams.imprest = scope.row.imprest"
          >
            <div>
              <el-input
                style="margin-bottom: 10px"
                v-model="reviseParams.imprest"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                type="primary"
                size="mini"
                @click="imprestConfirm(scope)"
                >确定</el-button
              >
            </div>
            <i
              class="el-icon-edit"
              slot="reference"
              v-if="department == '6' || department == '7'"
            ></i>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        slot="operation_frequency"
        width="100"
        align="center"
        label="操作频次"
        :filters="ofFilterList"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.operation_frequency }}</div>
        </template>
      </el-table-column>

      <!-- 详情 -->
      <el-table-column
        slot="info_detail"
        align="center"
        label="客户信息详情"
        width="105"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="success"
            plain
            size="mini"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>

      <!-- 店长 -->
      <el-table-column
        slot="assign_name"
        width="60"
        align="center"
        label="店长"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.assign_name }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="group_name" width="60" align="center" label="组长">
        <template slot-scope="scope">
          <div>{{ scope.row.assign_name_leader }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="sale_id" align="center" label="销售" width="60">
        <template slot-scope="scope">
          <div>{{ scope.row.sale_name }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="viewable_person"
        width="200"
        align="center"
        label="相关销售"
      >
        <template slot-scope="scope">
          {{ scope.row.viewable_name.join("、") }}
        </template>
      </el-table-column>

      <el-table-column slot="incall" width="80" align="center" label="incall">
        <template slot-scope="scope">
          <div v-if="scope.row.incall == '1'" class="fontColor_success">是</div>
          <div v-if="scope.row.incall == '0'" class="fontColor_theme">否</div>
          <div v-if="scope.row.incall == ''" class="fontColor_info">未确定</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="is_contract"
        align="center"
        label="是否断约"
        width="70"
      >
        <template slot-scope="scope">
          <div
            :class="
              scope.row.is_contract == '1'
                ? 'fontColor_danger'
                : 'fontColor_theme'
            "
          >
            {{ scope.row.is_contract == "1" ? "断约" : "否" }}
          </div>
        </template>
      </el-table-column>

      <!-- 客户姓名 -->
      <!-- <el-table-column
            slot="customer_name"
            width="120"
            align="center"
            label="客户姓名"
        >
            <template slot-scope="scope">
                <div>{{scope.row.customer_name}}</div>
            </template>
        </el-table-column> -->
      <el-table-column
        slot="zhipai"
        align="center"
        label="指派操作"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="warning"
            plain
            size="mini"
            @click="openAssignDia(scope.row, '指派店长')"
            >修改指派</el-button
          >
        </template>
      </el-table-column>

      <el-table-column
        slot="zhipai"
        align="center"
        label="指派销售"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="primary"
            plain
            size="mini"
            @click="openAssignDia(scope.row, '指派销售')"
            >指派销售</el-button
          >
        </template>
      </el-table-column>

      <!-- 添加小记操作 -->
      <el-table-column
        slot="addBtn"
        align="center"
        label="新建沟通小记"
        width="105"
      >
        <template slot-scope="scope">
          <!-- <el-button class="tableBtn_width" type="primary" plain size="mini" @click="openDialog(scope.row,true)">新建小记</el-button> -->
          <el-link type="success" @click="openDialog(scope.row, true)"
            >新建小记</el-link
          >
        </template>
      </el-table-column>

      <el-table-column
        slot="kill_contract"
        align="center"
        label="断约操作"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="danger"
            plain
            size="mini"
            @click="openDYDialog(scope.row)"
            :disabled="scope.row.is_contract == '0' ? false : true"
            >断约</el-button
          >
        </template>
      </el-table-column>

      <!-- 到期天数 -->
      <el-table-column
        slot="due_day"
        label="到期天数"
        align="center"
        width="140"
      >
        <template slot-scope="{ row }">
          <!-- 无延期日期时展示 -->
          <!-- 有延期日期时，判断是否小于7天，未过期，则展示延期日期 -->
          <div
            v-if="
              row.deferred_time && row.deferred_time.indexOf('timeout') === -1
            "
          >
            <span class="fontColor_success">
              延期至{{ row.deferred_time }}
            </span>
          </div>
          <div v-else>
            <span v-if="row.due_day <= 0" class="fontColor_danger">
              已到期 {{ Math.abs(row.due_day) }}天
            </span>
            <span v-else>{{ row.due_day }}天后</span>
            <el-button
              v-if="row.due_day <= 7"
              type="primary"
              plain
              size="mini"
              @click="deferContractHandle(row)"
            >
              申请延期
            </el-button>
          </div>
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 总数量和总金额统计 -->
    <!-- <div class="totalAmount">
        <p>总金额：<span>{{zje == ''? 0 : zje}}.00 元</span></p>
        <p>总数量：<span>{{zsl}}</span></p>
      </div> -->

    <!-- 添加小记对话框 -->
    <el-dialog
      title="新建沟通小记"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="addClose"
    >
      <!-- 表单部分 -->
      <el-form
        :model="touchForm"
        :rules="touchRules"
        ref="touchForm"
        label-width="100px"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="touchForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公司编号" prop="id">
          <el-input v-model="touchForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作人" prop="user_name">
          <el-input v-model="touchForm.user_name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="沟通小记" prop="contact_Records">
          <el-input
            type="textarea"
            v-model="touchForm.contact_Records"
            autosize
          ></el-input>
        </el-form-item>
        <el-form-item label="沟通方式" prop="contact_meth">
          <el-input v-model="touchForm.contact_meth"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="touchForm.remarks"></el-input>
        </el-form-item>
        <el-form-item label="审核" prop="to_examine">
          <el-input v-model="touchForm.to_examine"></el-input>
        </el-form-item>
        <el-form-item label="投诉" prop="complaint">
          <el-input v-model="touchForm.complaint"></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹出确认框 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTouchInfo('touchForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 指派客户对话框 -->
    <el-dialog
      :title="assign_title"
      :visible.sync="assignVisible"
      width="500px"
      :before-close="assignClose"
    >
      <el-form
        :model="assignForm"
        ref="assignForm"
        label-width="100px"
        :show-message="false"
        v-if="assign_title == '指派店长'"
      >
        <!-- <el-form-item label="客户编号" prop="id">
            <el-input v-model="assignForm.id" disabled></el-input>
          </el-form-item> -->
        <el-form-item label="公司名称">
          <el-input
            v-model="assignForm.name"
            disabled
            class="commit_input_wd"
          ></el-input>
        </el-form-item>
        <el-form-item label="店长" prop="assign_id" required>
          <el-select
            v-model="assignForm.assign_id"
            placeholder="请选择指派人"
            clearable
            filterable
            class="commit_input_wd"
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组长" prop="assign_id_leader" required>
          <el-select
            v-model="assignForm.assign_id_leader"
            placeholder="请选择指派人"
            clearable
            filterable
            class="commit_input_wd"
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主管" prop="assign_id_supervisor" required>
          <el-select
            v-model="assignForm.assign_id_supervisor"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in operateSuperOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 指派客户给销售表单↓↓↓↓ -->
      <el-form
        v-else
        :model="assignForm"
        ref="assignForm"
        label-width="100px"
        :show-message="false"
      >
        <!-- <el-form-item label="客户编号" prop="id">
            <el-input v-model="assignForm.id" disabled></el-input>
          </el-form-item> -->
        <el-form-item label="公司名称">
          <el-input
            v-model="assignForm.name"
            disabled
            class="commit_input_wd"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售指派" prop="sale_id" required>
          <el-select
            v-model="assignForm.sale_id"
            placeholder="请选择指派人"
            filterable
            class="commit_input_wd"
          >
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignVisible = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="assignHandle('assignForm')"
          :loading="btnLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 断约客户对话框 -->
    <el-dialog
      title="客户断约"
      :visible.sync="dyVisible"
      width="600px"
      :before-close="addClose"
    >
      <el-form
        class="form-main"
        label-width="80px"
        ref="dyFormRef"
        :model="formDYData"
        :rules="breakRules"
        size="small"
      >
        <el-form-item prop="is_refund">
          <el-radio-group v-model="formDYData.is_refund">
            <el-radio label="0" border>无退款</el-radio>
            <el-radio label="1" border>有退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="formDYData.is_refund == 1">
          <el-form-item prop="refund_time" label="退款时间">
            <el-date-picker
              v-model="formDYData.refund_time"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="refund_money" label="退款金额">
            <el-input v-model="formDYData.refund_money"> </el-input>
          </el-form-item>
          <el-form-item prop="refund_details" label="退款内容">
            <el-input
              v-model="formDYData.refund_details"
              type="textarea"
              placeholder="请填写退款内容"
              :rows="3"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="断约原因" prop="details">
          <el-input
            v-model="formDYData.details"
            type="textarea"
            placeholder="请填写断约原因"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dyVisible = false" :loading="btnLoading">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="insertcontract()"
          :loading="btnLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 导出对话框 -->
    <div class="dialog_box">
      <listExportXlsx
        :exportDataAll="exportDataAll"
        :exportClickTag="exportClickTag"
        @getApiParams="getApiParamsFunc"
        apiName="customerListExport"
      ></listExportXlsx>
    </div>

    <!-- 合同延期申请 -->
    <el-dialog title="延期申请" :visible.sync="deferVis" width="600px">
      <DeferApplyComp
        v-if="deferVis"
        :autoInput="deferAutoInput"
        @deferApplyParams="(e) => (deferApplyParams = e)"
      >
      </DeferApplyComp>

      <span slot="footer">
        <el-button @click="deferVis = false" :loading="btnLoading">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="deferApplyHandle()"
          :loading="btnLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <DetailContract :detailConfig="detailConfig"></DetailContract>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import countTo from "vue-count-to";
import moment from "moment";
import options from "@/libs/common.js";
import { numberValidate } from "@/libs/validate.js";
export default {
  components: {
    countTo,
    DeferApplyComp: () =>
      import("@/components/workOrder/contractDeferApply.vue"),
  },
  data() {
    // let currentPage = utils.sessionGetStore('currentPage')
    // currentPage = currentPage == null ? 1 : currentPage
    // console.log(typeof(currentPage))
    return {
      isFoldQuery: false,
      monthPickerOptions: options.monthPickerOptions,
      department: utils.sessionGetStore("department"),
      // currentPage: Number(currentPage),
      //筛选条件
      valueDate: [], //签订日期区间
      dqsjDate: [], //到期时间区间
      cnOption: [
        {
          value: "",
          label: "全部",
        },
      ], //公司名选项

      //表格内容相关
      dataList: [], //表格数据列表
      //列的数据 插槽站位
      columnsList: [
        // {
        //   label:'新建沟通小记',
        //   slotName:"addBtn"
        // },
        // {
        //     label:"编号",
        //     slotName:"id"
        // },
        {
          label: "公司名称",
          slotName: "corporate_name",
        },
        {
          label: "品牌名称",
          slotName: "brand_name",
        },
        {
          label: "签订时间",
          slotName: "cooperation_time",
        },
        {
          label: "到期时间",
          slotName: "due_time",
        },
        {
          label: "到期天数",
          // prop: "due_day",
          slotName: "due_day",
        },
        {
          label: "合同金额",
          slotName: "contract_amount",
        },
        {
          label: "实际服务金额",
          slotName: "cooperation_amount",
        },
        {
          label: "波罗蜜",
          slotName: "boluomi",
        },
        {
          label: "店长",
          slotName: "assign_name",
        },
        // {
        //   label:"购买备用金",
        //   slotName:"imprest"
        // },
        // {
        //   label:"品牌类型",
        //   slotName:"category"
        // },
        {
          label: "平台",
          prop: "plt",
          width: 200,
        },
        {
          label: "操作频次",
          slotName: "operation_frequency",
        },
        {
          label: "sku数",
          prop: "sku_num",
        },
        {
          label: "购买次数", // 合同购买数量
          prop: "contract_num",
        },
        {
          label: "类目",
          prop: "category",
        },
        {
          label: "主要产品",
          prop: "main_products",
        },
        {
          label: "是否分期",
          slotName: "payment_method",
        },
        {
          label: "合作性质",
          slotName: "properties",
        },
        {
          label: "组长",
          slotName: "group_name",
        },
        {
          label: "运营主管",
          prop: "assign_name_supervisor",
        },
        {
          label: "销售",
          slotName: "sale_id",
        },
        {
          label: "相关销售",
          slotName: "viewable_person",
        },
        {
          label: "incall",
          slotName: "incall",
        },
        // {
        //   label:"是否断约",
        //   slotName:'is_contract'
        // },
        // {
        //   label:"最近沟通时间",
        //   slotName:"touch_time"
        // },
        // {
        //   label:'联系人',
        //     prop:'contacts'
        // },
        // {
        //   label:'职务',
        //   prop:'contacts_post'
        // },
        // {
        //   label:'联系人电话',
        //   prop:'contacts_phone',
        //   width:120
        // },
        // {
        //   label:"客户姓名",
        //   slotName:"customer_name"
        // },
        // {
        //   label:"客户信息详情",
        //   slotName:"info_detail"
        // },

        {
          label: "指派操作",
          slotName: "zhipai",
        },
        {
          label: "断约操作",
          slotName: "kill_contract",
        },
      ],
      // 主动跟新数据标记
      updateDataTag: false,
      resetPageNum: true, // 是否重置页面
      // 数据总条数
      totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名
      getTabData: {
        start: "",
        end: "",
        corporate_name: "", //公司名 默认空
        due_time_start: "", //到期开始时间
        due_time_end: "", // 到期结束时间
        brand_name: "", // 品牌名
        assign_id: "", // 店长
        assign_name_leader: "", // 组长
        properties: "", // 客户类型
        contract_amount_state: "", // 合同金额区间开始
        contract_amount_end: "", // 合同金额结束
        category: "", //类目
        sale_id: "", //销售
        order: "", // 到期天数排序
        payment_method: "", // 是否分期 1否 2 是
        incall: "", // 是否客户主动打入 0-否 1-是
        main_products: "", // 主要产品
        id: "", // 默认查登录人，最高权限可查销售主管
        is_Purchase: "",
        group: "", //运营一部：静微、聂敏、小平；二部：灶丽、夏娇
      }, //表格数据查询条件
      supervisorId: "",
      // 客户类型选项
      khlxOption: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "新签",
        },
        {
          value: 2,
          label: "续签",
        },
        {
          value: 3,
          label: "新签新增",
        },
        {
          value: 4,
          label: "续签新增",
        },
      ],

      // 沟通小记数据
      dialogVisible: false, //新建沟通小记对话框是否显示
      touchForm: {
        complaint: "",
        id: "", //客户编号
        user_name: "", //操作人
        contact_Records: "", //沟通小记
        contact_meth: "", //沟通方式
        remarks: "", //备注
        to_examine: "", //审核
        complaint: "", //投诉
      },
      touchRules: {
        //验证规则
        contact_Records: [
          { required: true, message: "请填写沟通小记", trigger: "change" },
        ],
        contact_meth: [
          { required: true, message: "请填写沟通方式", trigger: "change" },
        ],
        complaint: [],
        id: [],
        user_name: [],
        remarks: [],
        to_examine: [],
        complaint: [],
      },

      // 指派客户
      assign_title: "", // 指派对话框标题
      assignVisible: false, // 对话框显示
      assignForm: {
        // 指派客户表单---运营
        id: "", // 单条编号
        work_order_id: "", // 所属工单id
        assign_id: "", //被指派店长id
        name: "", //客户名称
        assign_id_leader: "", // 指派组长id
        assign_id_supervisor: "",
        sale_id: "", // 销售id
        customer_id: "", // 客户id-添加销售流转记录用
      },
      assignRules: {
        //验证规则
        id: [
          { required: true, message: "请填写客户编号", trigger: "change" },
          // {type:'number',message:"客户编号必须为数字"}
        ],
        assign_id: [{ required: true, message: "请选择店长", trigger: "blur" }],
        sale_id: [{ required: true, message: "请选择销售", trigger: "blur" }],
        assign_id_leader: [],
      },
      jurisdiction: true, //权限 0:true    1,2:false

      zje: "", //总金额
      zsl: "", //总数量
      // 导出相关
      exportDataAll: [
        // {
        //   chinese: '客户编号',
        //   english: 'id'
        // },
        {
          chinese: "公司名称",
          english: "corporate_name",
        },
        {
          chinese: "品牌名称",
          english: "brand_name",
        },
        {
          chinese: "签订时间",
          english: "cooperation_time",
        },
        {
          chinese: "到期时间",
          english: "due_time",
        },
        {
          chinese: "到期天数",
          english: "due_day",
        },
        {
          chinese: "合同金额",
          english: "contract_amount",
        },
        {
          chinese: "实际服务金额",
          english: "cooperation_amount",
        },
        {
          chinese: "平台",
          english: "plt",
        },
        {
          chinese: "操作频次",
          english: "operation_frequency",
        },
        {
          chinese: "sku数",
          english: "sku_num",
        },
        {
          chinese: "购买次数",
          english: "contract_num",
        },
        {
          chinese: "品牌类目",
          english: "category",
        },
        {
          chinese: "主要产品",
          english: "main_products",
        },
        {
          chinese: "是否分期",
          english: "payment_method",
        },
        {
          chinese: "合作性质",
          english: "properties",
        },
        {
          chinese: "店长",
          english: "assign_name",
        },
        {
          chinese: "组长",
          english: "assign_name_leader",
        },
        {
          chinese: "销售",
          english: "sale_name",
        },
        // {
        //   chinese: '相关销售',
        //   english: 'viewable_person'
        // },
        {
          chinese: "最近沟通时间",
          english: "touch_time",
        },
        {
          chinese: "是否incall",
          english: "incall",
        },
        {
          chinese: "保密协议",
          english: "is_secrecy_export",
        },
        {
          chinese: "控价/未授权",
          english: "control_unauthorized",
        },
      ],
      exportClickTag: false, // 点击导出标记

      // 断约相关
      formDYData: {
        details: "", // 断约原因
        is_refund: "0", //是否退款（0否1是）
        refund_time: "", //退款时间
        refund_money: "", //退款金额
        refund_details: "", //退款内容
      },
      breakRules: {
        refund_money: [
          {
            required: true,
            validator: numberValidate,
            trigger: "blur",
          },
        ],
        details: [
          { required: true, message: "请填写断约原因", trigger: "blur" },
        ],
        refund_time: [
          { required: true, message: "请选择退款时间", trigger: "change" },
        ],
        refund_details: [
          { required: true, message: "请填写退款内容", trigger: "blur" },
        ],
      },
      dyVisible: false, // 断约弹窗显示状态
      dyComtomer_id: "", // 断约客户id
      dyCustomer_file_id: "", // 断约客户档案id
      btnLoading: false,

      // 筛选操作频次
      ofFilterList: [],
      reviseParams: {
        boluomi: "",
        // imprest: '', // 购买备用金
      },

      // 延期申请
      deferVis: false,
      deferAutoInput: {},
      deferApplyParams: null,

      // 详情查看
      detailConfig: {
        showSign: 0,
        contractProp: null,
      },
    };
  },
  watch: {},
  computed: {
    // 运营主管
    operateSuperOptions() {
      let leader = this.$store.state.leaderOptions.filter(
        (item) => item.value == "4",
      )[0].options;
      return [
        ...leader.filter((item) => item.post == "10"),
        { label: "龚蕾", value: "2" },
      ];
    },
    groupLeaderOptions() {
      return this.$store.getters.groupLeaderOptions;
    },
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
    operatePersonOptions() {
      return this.$store.getters.operatePersonOptions;
    },
    categoryOptions() {
      return this.$store.getters.categoryOptions;
    },
    operationDepartmentOptions() {
      return this.$store.state.commonOptions.operationDepartmentOptions;
    },
  },
  methods: {
    deferContractHandle(row) {
      this.deferAutoInput = {
        customer_file_id: row.customer_file_id,
        customer_id: row.customer_id,
        work_order_id: row.work_order_id,
        corporate_name: row.corporate_name,
        shop_name: row.shop_name,
        brand_name: row.brand_name,
        // deferred_days: row.deferred_days, // 新申请延期时，就覆盖掉之前的，不再带入上次的延期天数
        due_time: row.due_time,
        due_day: row.due_day,
      };
      this.deferVis = true;
    },
    deferApplyHandle() {
      if (this.deferApplyParams === null) {
        this.$message.warning("请设置延期天数");
        return;
      }
      let paramObj = {
        ...this.deferApplyParams,
        applicant: this.userId, // 申请人
      };
      this.btnLoading = true;
      this.$api
        .deferContractApplyFunc(paramObj)
        .then((res) => {
          // console.log(res);
          if (res.data.code === 0) {
            this.deferVis = false;
            this.$tools.notificationInfo(
              "消息",
              "延期申请已提交，请等待审核",
              "success",
            );
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("操作失败，请重试");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 更新状态
    setRPN(e) {
      this.resetPageNum = e;
    },
    //  筛选操作频次
    filterHandler(value, row, column) {
      let of = row.operation_frequency;
      return of.indexOf(value) != -1 ? true : false;
    },

    // 关闭popover---波罗蜜
    closePop(scope) {
      // console.log(scope)
      // console.log(scope.$index)
      this.$refs[`re-popover-${scope.$index}`].doClose();
    },

    // 断约相关
    // 开启断约弹框
    openDYDialog(row) {
      this.dyComtomer_id = row.customer_id;
      // 客户档案id 20230926
      this.dyCustomer_file_id = row.customer_file_id;
      this.dyVisible = true;
    },
    // 客户断约状态操作
    //
    insertcontract() {
      this.$refs.dyFormRef.validate((valid) => {
        if (valid) {
          let paramObj = {
            id: this.dyComtomer_id,
            customer_file_id: this.dyCustomer_file_id,
            is_contract: "1",
            ...this.formDYData,
          };
          this.btnLoading = true;
          api
            .breakContract(paramObj)
            .then((res) => {
              // console.log(res)
              if (res.data.code == 0) {
                utils.notificationInfo("提示", "该客户已设置为断约", "success");
                // 更新
                this.updateDataTag = !this.updateDataTag;

                this.resetPageNum = false;

                this.dyVisible = false;
                Object.keys(this.formDYData).forEach((key) => {
                  if (key == "is_refund") {
                    this.formDYData[key] = "0";
                  } else {
                    this.formDYData[key] = "";
                  }
                });
                this.dyComtomer_id = "";
              }
            })
            .catch((error) => {
              console.log(error);
              utils.notificationInfo("提示", "设置断约状态失败", "warning");
            })
            .finally(() => (this.btnLoading = false));
        }
      });
    },

    //  打开客户指派对话框
    openAssignDia(data, type) {
      Object.keys(this.assignForm).forEach((key) => {
        this.assignForm[key] = "";
      });

      this.assignForm.work_order_id = data.work_order_id; // 取工单编号 2022-06-13

      this.assignForm.name = data.corporate_name;

      this.assignVisible = true;

      this.assign_title = type;
      if (type == "指派店长") {
        this.assignForm.id = data.customer_id;
      } else if (type == "指派销售") {
        // 绑定单次合作记录
        this.assignForm.id = data.id;
        // 添加客户流转记录
        this.assignForm.customer_id = data.customer_id;
      }
      if (data.sale_id != "") {
        this.assignForm.sale_id = data.sale_id;
      }
      if (
        data.assign_id_leader != "" &&
        data.assign_id_leader != null &&
        data.assign_id_leader != "null"
      ) {
        // 组长
        this.assignForm.assign_id_leader = data.assign_id_leader;
      }
      if (
        data.assign_id != "" &&
        data.assign_id != null &&
        data.assign_id != "null"
      ) {
        this.assignForm.assign_id = data.assign_id;
      }
      if (data.assign_id_supervisor) {
        this.assignForm.assign_id_supervisor = data.assign_id_supervisor;
      }
    },
    //  客户指派操作
    assignHandle(fN) {
      // 表单验证
      this.$refs[fN].validate((valid) => {
        if (valid) {
          let paramObj = {};
          Object.keys(this.assignForm).forEach((item) => {
            if (this.assignForm[item] != "") {
              paramObj[item] = this.assignForm[item];
            }
          });
          paramObj.up_user = this.userId;
          // console.log(paramObj)
          if (this.assign_title == "指派销售") {
            this.btnLoading = true;
            api
              .saleAssign(paramObj)
              .then((res) => {
                // console.log(res)
                utils.notificationInfo("提示", "指派成功", "success");
                // 主动更新数据标记---更新
                this.updateDataTag = !this.updateDataTag;
                this.resetPageNum = false;
                // 重置表单
                this.$refs[fN].resetFields();
                this.assignVisible = false;
              })
              .catch((error) => {
                console.log(error);
                utils.notificationInfo("提示", "指派失败", "error");
              })
              .finally(() => {
                this.btnLoading = false;
              });
          } else {
            // 指派给运营
            paramObj.state = "1"; //指派状态 1 已指派
            this.btnLoading = true;

            api
              .customerAssign(paramObj)
              .then((res) => {
                utils.notificationInfo("提示", "指派成功", "success");
                // 主动更新数据标记---更新
                this.updateDataTag = !this.updateDataTag;
                this.resetPageNum = false;
                // 重置表单
                this.$refs[fN].resetFields();
                this.assignVisible = false;
              })
              .catch((err) => {
                console.log(err);
                utils.notificationInfo("提示", "指派失败", "error");
              })
              .finally(() => {
                this.btnLoading = false;
              });
          }
        }
      });
    },
    // 关闭对话框前触发
    assignClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //
    //  新建小记对话框,
    //
    // 在点击对话框之外时，会弹出此对话框
    addClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 开启对话框
    openDialog(scope, view) {
      // console.log("沟通小记",scope,this.userName)
      this.dialogVisible = view;
      this.touchForm.name = scope.corporate_name; //公司名
      this.touchForm.id = scope.id;
      this.touchForm.user_name = this.userName;
    },
    //确认新建
    addTouchInfo(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          let paramObj = {
            e_id: this.touchForm.id,
            user_id: this.userId,
            communicate_record: this.touchForm.contact_Records,
            communication_mode: this.touchForm.contact_meth,
            remarks: this.touchForm.remarks,
            to_examine: this.touchForm.to_examine,
            complaint: this.touchForm.complaint,
          };
          api
            .addTouchInfo(paramObj)
            .then((res) => {
              utils.notificationInfo("提示", "新建成功", "success");
              // 主动更新数据标记---更新
              this.updateDataTag = !this.updateDataTag;
              // 重置表单
              this.$refs[formName].resetFields();
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "新建失败", "error");
            });
        } else {
          // console.log('error submit!!');
          utils.notificationInfo("提示", "新建失败", "error");
          return false;
        }
      });
    },

    //  添加波罗蜜
    // 点击 波罗蜜的修改图标
    remarkEditClick(index) {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].boluomiVisible = false;
      }
      this.dataList[index].boluomiVisible = true;
    },
    // 修改波罗蜜
    remarkEditConfirm(row, index, d) {
      // console.log(row.boluomi);
      // console.log(d)
      let paramObj = {
        id: row.id,
        // boluomi: this.reviseParams.boluomi || 0,
        boluomi: row.boluomi || "",
      };
      utils.debounceFunc(() => {
        // api
        api
          .reviseBoluomi(paramObj)
          .then((res) => {
            // console.log(res)
            this.$message.success("内容已自动保存");
            this.dataList[index].boluomiVisible = false;
            this.reviseParams.boluomi = "";
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }, 2000);
    },

    // 修改备用金
    imprestConfirm(data) {
      if (this.reviseParams.imprest === "") return;
      let paramObj = {
        id: data.row.id,
        imprest: this.reviseParams.imprest,
      };
      api
        .reviseImprest(paramObj)
        .then((res) => {
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
          this.reviseParams.imprest = "";
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("修改失败");
        });
    },

    //
    //
    //跳转详情页
    //
    // 弃用
    goToDetail(row) {
      if (this.getTabData.is_Purchase) {
        return;
      }
      // console.log('detail',row)
      let r = this.$router.resolve({
        path: "/index/customerManage/customerInfoDetail",
        query: {
          // orderId:row.id,
          orderId: row.customer_id,
          customer_file_id: row.customer_file_id,
          corporate_name: row.corporate_name, //公司名
          sign: 0,
          assign_id: row.assign_id,
        },
      });
      window.open(r.href, "_blank");
    },
    handleDetail(row) {
      // 购买人员 只读
      if (this.getTabData.is_Purchase) {
        return;
      }
      this.detailConfig.showSign++;
      this.detailConfig.contractProp = {
        sign: 0, // 进入详情类型标识  // 签约客户
        ...row,
      };
    },
    salesChange() {
      this.getTabData.id = this.supervisorId;
      this.searchBtn();
    },
    valueDateChange() {
      if (this.valueDate && this.valueDate.length > 0) {
        this.getTabData.start = this.valueDate[0];
        this.getTabData.end = moment(this.valueDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.start = "";
        this.getTabData.end = "";
      }
      this.searchBtn();
    },
    dueTimeChange() {
      if (this.dqsjDate && this.dqsjDate.length > 0) {
        this.getTabData.due_time_start = this.dqsjDate[0];
        this.getTabData.due_time_end = moment(this.dqsjDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.due_time_start = "";
        this.getTabData.due_time_end = "";
      }
      this.searchBtn();
    },
    searchBtn() {
      utils.debounceFunc(() => {
        utils.sessionSetStore("customSearch", this.getTabData);
        this.updateDataTag = !this.updateDataTag;
      });
    },

    //重置查询
    resetSearch() {
      this.valueDate = [];
      this.dqsjDate = [];
      Object.keys(this.getTabData).forEach((key) => {
        this.getTabData[key] = "";
      });
      this.getTabData.id = this.userId;
      this.supervisorId = "";
      // 清除本地查询条件
      utils.sessionRemoveStore("customSearch");

      this.updateDataTag = !this.updateDataTag;
    },

    //表格数据获取
    dataQueryFunc() {
      let paramObj = {};
      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key]) {
          paramObj[key] = this.getTabData[key];
        }
      });
      paramObj.is_contract = 0;

      return {
        apiName: "getCustomersData",
        paramObj: paramObj,
        success: function (response, callBack) {
          this.zje = Number(response.data.data.contract_amount_Count);
          this.zsl = Number(response.data.data.totalCount);

          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });

            // 相关销售姓名转换
            obj.viewable_name = [];
            if (obj.viewable_person) {
              obj.viewable_person = obj.viewable_person.split(","); // 转为数组
              obj.viewable_person.forEach((userID) => {
                obj.viewable_name.push(this.$tools.conversionName(userID));
              });
            }
            //公司名称选项-----名称过多，弃用-----2020——10——26
            let addName = true; //是否添加公司名
            this.cnOption.forEach((item) => {
              if (item.label == records[i].corporate_name) {
                addName = false;
              }
            });
            if (addName) {
              this.cnOption.push({
                value: records[i].corporate_name,
                label: records[i].corporate_name,
              });
            }

            obj.boluomiVisible = false; // 添加波罗蜜的小框默认不显示

            // 延期信息展示
            // 若已申请延期的日期也已过期，则继续显示原合同到期天数
            if (obj.deferred_time) {
              let defer = new Date(obj.deferred_time).getTime();
              let now = new Date().getTime();
              defer < now ? (obj.deferred_time += "-timeout") : "";
            }

            arr.push(obj);
          }
          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function (error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },

    // 点击导出按钮
    exportClick() {
      // 点击导出标记更新， 子组件调用打开导出对话框
      this.exportClickTag = !this.exportClickTag;
    },
    // 导出时api的参数处理
    getApiParamsFunc(callBack) {
      // 若没有带条件查询，导出全部
      let paramObj = {
        id: this.userId,
        is_contract: 0,
      };
      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key]) {
          paramObj[key] = this.getTabData[key];
        }
      });
      // 执行回调
      callBack(paramObj);
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");
    this.getTabData.id = this.userId;

    // 获取权限
    let jur = utils.sessionGetStore("jurisdiction");
    this.jurisdiction =
      jur == "0" &&
      (this.department == "6" || this.department == "7" || this.userId == 2)
        ? true
        : false;

    if (this.jurisdiction) {
      this.exportDataAll.push({
        chinese: "波罗蜜",
        english: "boluomi",
      });
    }

    // 获取存在本地的查询条件
    let customSearch = JSON.parse(utils.sessionGetStore("customSearch"));
    // console.log(customSearch)
    if (customSearch) {
      this.getTabData = customSearch;
      if (this.getTabData.id != this.userId) {
        this.supervisorId = this.getTabData.id;
      }
      this.valueDate = [this.getTabData.start, this.getTabData.end];
      this.dqsjDate = [
        this.getTabData.due_time_start,
        this.getTabData.due_time_end,
      ];
    }

    // 监听本地
    // window.addEventListener('setItem',()=> {
    //   this.currentPage = Number(utils.sessionGetStore('currentPage'))
    // })

    let ofArr = this.$store.state.commonOptions.operationFreqOption;
    ofArr.forEach((item) => {
      this.ofFilterList.push({
        text: item.value,
        value: item.value,
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  // border-top: 1px solid #fff;
  // border-left: 1px solid #fff;
  .totalAmount {
    // background: #409EFF;
    // margin-bottom: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #fff;
    > div {
      padding: 0px 30px;
      background: linear-gradient(90deg, rgba(57, 208, 148, 0.7) 0, #fff 100%);
      line-height: 24px;
      height: 24px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      color: #fff;

      > p {
        float: left;
        margin-right: 20px;
        > span {
          // color:#409EFF;
          // color: #04B991;
        }
      }
    }
  }
  .queryBox {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }

  .account-view {
    padding: 5px;
    background-color: #fff;
    display: flex;

    .ac-result {
      margin: 0 20px;
      > span {
        font-size: 14px;
      }
      .label {
        line-height: 1;
      }
      &:nth-child(2) {
        margin-left: 50px;
      }
      .cn_num {
        // color: #00B791;
        color: #0f70ee;
        font-weight: bold;
      }
    }
  }

  .tabComtent {
    background: #fff;
    height: 100%;
  }

  // .totalAmount{
  //   position: relative;
  //   width: 300px;
  //   left: 20px;
  //   margin-top:-50px;

  //   >p{
  //     font-size: 16px;
  //     font-weight: 500;
  //     >span{
  //       font-size: 16px;
  //       color:#409EFF;
  //     }
  //   }
  // }
}
</style>
